import enImages from 'src/components/laws/interactive-picture/field-of-play/images/en'
import deImages from 'src/components/laws/interactive-picture/field-of-play/images/de'
import esImages from 'src/components/laws/interactive-picture/field-of-play/images/es'
import frImages from 'src/components/laws/interactive-picture/field-of-play/images/fr'

const images = [...enImages, ...deImages, ...esImages, ...frImages]

export default images
